import i18n from 'i18next';
import {
  applyDocumentLanguage,
  isAppLanguageCode,
  LOCALE_STORAGE_KEY,
  type AppLanguageCode,
} from './languages';
import { resolveLanguageAgainstAllowlist } from '../useEnabledLanguages';

/** Persist UI language for the signed-in user (Azure SQL via /api/users/me/preferred-locale). */
export async function persistPreferredLocale(locale: AppLanguageCode): Promise<void> {
  const allowed = resolveLanguageAgainstAllowlist(locale);
  try {
    const res = await fetch('/api/users/me/preferred-locale', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ preferred_locale: allowed }),
    });
    if (!res.ok) {
      // Non-fatal: localStorage still holds the preference for this browser.
      console.warn('[i18n] Failed to persist preferred_locale', res.status);
    }
  } catch (err) {
    console.warn('[i18n] Failed to persist preferred_locale', err);
  }
}

/** Apply a locale from the server profile (overrides stale localStorage). */
export function applyPreferredLocaleFromProfile(preferredLocale: unknown): void {
  const raw = String(preferredLocale ?? '').trim().toLowerCase();
  if (!isAppLanguageCode(raw) && raw !== '') return;
  const next = resolveLanguageAgainstAllowlist(raw || 'en');
  applyDocumentLanguage(next);
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, next);
  } catch {
    // Ignore storage errors.
  }
  if (i18n.language !== next) {
    void i18n.changeLanguage(next);
  }
}
